import { useQuery } from '@tanstack/react-query'
import { orgformKodeKeys, OrgformKodeKeys } from '../queries/helpers'
import { orgformKodeApi } from '../queries/orgform-kode-api'

export { useOrgformKode }

const useOrgformKode = <TData = string, TError = Error>(
  orgNr?: string,
  tilsynsobjektId?: string
) =>
  useQuery<string, TError, TData, ReturnType<OrgformKodeKeys['get']>>({
    queryKey: orgformKodeKeys.get(orgNr, tilsynsobjektId),
    queryFn: async () => {
      const tilsynsobjektData = tilsynsobjektId
        ? (await orgformKodeApi.getTilsynsobjektData(tilsynsobjektId)).data
        : undefined

      const orgnummer = tilsynsobjektData.orgNr || orgNr
      if (!orgnummer) return ''

      const { data } = await orgformKodeApi.get(orgnummer)

      return data.organisasjonsformKode
    },
    enabled: !!orgNr || !!tilsynsobjektId,
  })
